import React from 'react';
import { MarkdownRenderer } from '@/components/MarkdownRenderer';
import { ServerLogoWithFallback } from '@/components/ServerLogoWithFallback';

interface ServerCardContentProps {
  name: string;
  description: string;
  logoImageUrl?: string;
  gameFallbackImage?: string;
  gameName?: string;
  serverId: string;
  fallbackVotes: number;
  playerCount?: string | null;
  isPrestige?: boolean;
}

export const ServerCardContent: React.FC<ServerCardContentProps> = ({
  name,
  description,
  logoImageUrl,
  gameFallbackImage,
  gameName,
  serverId,
  fallbackVotes: _fallbackVotes,
  playerCount: _playerCount,
  isPrestige = false,
}) => {
  return (
    <div className="relative z-10 flex items-start gap-3 p-3 sm:p-4">
      <div className="w-[96px] h-[96px] sm:w-[110px] sm:h-[110px] flex-shrink-0 overflow-hidden rounded-lg">
        <ServerLogoWithFallback
          serverId={serverId}
          name={name}
          logoImageUrl={logoImageUrl}
          gameFallbackImage={gameFallbackImage}
          gameName={gameName}
          size={110}
          className="w-full h-full object-cover rounded-lg"
          borderClassName="border border-blue-400/30 shadow-[0_0_10px_rgba(96,165,250,0.2)] hover:shadow-[0_0_16px_rgba(96,165,250,0.35)] transition-shadow duration-300"
        />
      </div>


      <div className="flex-1 min-w-0 pt-1">
        <h3 className="mb-1 line-clamp-1 text-lg font-extrabold leading-[1.15] text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)] sm:text-xl">
          {name}
        </h3>
        <div
          className={`text-xs sm:text-sm leading-relaxed text-slate-300/90 ${
            isPrestige ? 'prestige-scroll-container' : 'h-12 sm:h-14 overflow-hidden'
          }`}
          style={isPrestige ? { '--scroll-duration': `${Math.max(3, Math.round(description.length / 40))}s` } as React.CSSProperties : undefined}
        >
          <div className={isPrestige ? '' : 'line-clamp-3'}>
            <MarkdownRenderer
              content={description}
              className="prose-sm"
              textOnly={true}
              isPrestige={isPrestige}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
